import React, { useState, useEffect } from "react";

export default function ControlAccesos({ usuario, onBackToMenu }) {
  const [pestanaActiva, setPestanaActiva] = useState("empleado"); 
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ text: "", type: "" });
  
  const [sedes, setSedes] = useState([]);
  const [cargosBD, setCargosBD] = useState([]); 
  const [modulosEstructura, setModulosEstructura] = useState([]);
  const [moduloViendo, setModuloViendo] = useState(null); 
  
  const [busqueda, setBusqueda] = useState("");
  const [empleadoEncontrado, setEmpleadoEncontrado] = useState(null);
  const [cargoSeleccionado, setCargoSeleccionado] = useState("");
  
  const [permisosAvanzados, setPermisosAvanzados] = useState({}); 
  const [modulosMacroActivos, setModulosMacroActivos] = useState([]); 
  const [accesoGlobal, setAccesoGlobal] = useState(false); 
  const [accesoAlison, setAccesoAlison] = useState(false); 

  useEffect(() => {
    fetchSedes();
    fetchCargosDesdeBD();
    escanearModulosDelSistema();
  }, []);

  useEffect(() => {
    if (pestanaActiva === "cargo" && cargoSeleccionado) {
      cargarPermisosCargo(cargoSeleccionado);
    }
  }, [cargoSeleccionado, pestanaActiva]);

  const fetchSedes = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/sedes`);
      const data = await res.json();
      if (data.success) setSedes(data.data || []);
    } catch (e) { console.error(e); }
  };

  const fetchCargosDesdeBD = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/cargos`);
      const data = await res.json();
      if (data.success) setCargosBD(data.cargos || []);
    } catch (e) { console.error(e); }
  };

  const escanearModulosDelSistema = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/modulos/estructura`);
      const data = await res.json(); 
      if (data.success && data.estructura) {
        setModulosEstructura(data.estructura);
        if(data.estructura.length > 0) setModuloViendo(data.estructura[0].id);
      }
    } catch (error) {
      setMensaje({ text: "Error al escanear módulos.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const cargarPermisosCargo = async (cargo) => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/permisos/cargo/${encodeURIComponent(cargo)}`);
      const data = await res.json();
      if (data.success) {
        setModulosMacroActivos(data.permisos_macro || []);
        setPermisosAvanzados(data.permisos_avanzados || {});
        setAccesoGlobal(data.acceso_global === true); 
        setAccesoAlison(Boolean(data.permisos_avanzados?.alison)); // Cargamos el estado de Alison
      }
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  const handleBuscarEmpleado = async (e) => {
    e.preventDefault();
    if (!busqueda.trim()) return;
    setLoading(true); setMensaje({ text: "", type: "" });

    try {
      const cedula = busqueda.trim();
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscar?query=${cedula}`);
      const data = await res.json();
      
      const empleadoEncontradoObj = Array.isArray(data) ? data[0] : (data.usuario || data);

      if (empleadoEncontradoObj) {
        const empleadoNormalizado = {
          ...empleadoEncontradoObj,
          nombres: empleadoEncontradoObj.nombres || empleadoEncontradoObj.terc_nom || "Sin Nombre",
          cargo: empleadoEncontradoObj.cargo || empleadoEncontradoObj.cargo_usuario || empleadoEncontradoObj.empl_cargo || "Sin Asignar"
        };

        setEmpleadoEncontrado(empleadoNormalizado);
        setAccesoGlobal(Boolean(empleadoNormalizado.acceso_global_sedes)); 
        
        const resPermisos = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/permisos/usuario/${cedula}`);
        const dataPermisos = await resPermisos.json();

        if (dataPermisos.success) {
          setModulosMacroActivos(dataPermisos.permisos_macro_individual || []);
          setPermisosAvanzados(dataPermisos.permisos_avanzados || {});
          setAccesoAlison(Boolean(dataPermisos.permisos_avanzados?.alison)); 
        } else {
          setModulosMacroActivos([]); setPermisosAvanzados({}); setAccesoAlison(false);
        }
      } else {
        setMensaje({ text: "Colaborador no encontrado.", type: "error" });
        setEmpleadoEncontrado(null); setPermisosAvanzados({}); setModulosMacroActivos([]); setAccesoGlobal(false); setAccesoAlison(false);
      }
    } catch (err) { 
      setMensaje({ text: "Error de conexión.", type: "error" }); 
    } finally { setLoading(false); }
  };

  const handleToggleModuloMacro = (moduloId) => {
    const modulo = modulosEstructura.find(m => m.id === moduloId);
    setModulosMacroActivos(prev => {
      const isActivo = prev.some(id => String(id) === String(moduloId));
      if (isActivo) {
        if (modulo && modulo.subForms) {
          setPermisosAvanzados(prevMicros => {
            const nuevosMicros = { ...prevMicros };
            modulo.subForms.forEach(form => delete nuevosMicros[form]);
            return nuevosMicros;
          });
        }
        return prev.filter(id => String(id) !== String(moduloId)); 
      } else {
        return [...prev, moduloId]; 
      }
    });
  };

  const handleTogglePermisoMicro = (nombreFormulario) => {
    setPermisosAvanzados(prev => {
      const nuevos = { ...prev };
      if (nuevos[nombreFormulario]) {
        delete nuevos[nombreFormulario]; 
      } else {
        nuevos[nombreFormulario] = { alcance: "PROPIA", sedes_ids: [], ver: true, crear: false, editar: false, eliminar: false }; 
      }
      return nuevos;
    });
  };

  const handleCambiarAlcance = (nombreFormulario, campo, valor) => {
    setPermisosAvanzados(prev => ({
      ...prev,
      [nombreFormulario]: {
        ...prev[nombreFormulario],
        [campo]: valor,
        ...(campo === 'alcance' && valor !== 'ESPECIFICA' ? { sedes_ids: [] } : {})
      }
    }));
  };

  const handleToggleAccion = (nombreFormulario, accion) => {
    setPermisosAvanzados(prev => ({
      ...prev,
      [nombreFormulario]: {
        ...prev[nombreFormulario],
        [accion]: !prev[nombreFormulario][accion]
      }
    }));
  };

  const handleToggleSedeMultiple = (nombreFormulario, codigoBodega) => {
    setPermisosAvanzados(prev => {
      const actuales = prev[nombreFormulario]?.sedes_ids || [];
      const nuevasSedes = actuales.includes(codigoBodega) 
        ? actuales.filter(cod => cod !== codigoBodega) 
        : [...actuales, codigoBodega];
      return { ...prev, [nombreFormulario]: { ...prev[nombreFormulario], sedes_ids: nuevasSedes } };
    });
  };

  const handleGuardarPermisosUnificados = async () => {
    if (pestanaActiva === "empleado" && !empleadoEncontrado) return;
    if (pestanaActiva === "cargo" && !cargoSeleccionado) { setMensaje({ text: "Selecciona un cargo primero.", type: "warning" }); return; }
    setLoading(true);

    try {
      let endpoint = pestanaActiva === "empleado" 
        ? `${process.env.REACT_APP_API_URL}/api/usuarios/permisos/usuario`
        : `${process.env.REACT_APP_API_URL}/api/usuarios/permisos-unificados/cargo`;
        
      const macrosLimpios = [...new Set(modulosMacroActivos)].filter(macroId => 
        modulosEstructura.some(mod => String(mod.id) === String(macroId))
      );

      // Incluimos alison dentro de los permisos avanzados con su valor booleano
      const microsLimpios = { 
        ...permisosAvanzados, 
        alison: accesoAlison 
      };

      modulosEstructura.forEach(mod => {
        const modEstaActivo = macrosLimpios.some(id => String(id) === String(mod.id));
        if (!modEstaActivo && mod.subForms) {
          mod.subForms.forEach(form => { delete microsLimpios[form]; });
        }
      });

      const bodyData = { 
        permisos_macro: macrosLimpios, 
        permisos_avanzados: microsLimpios, 
        acceso_global: accesoGlobal 
      };

      if (pestanaActiva === "empleado") {
        bodyData.documento = empleadoEncontrado.documento;
      } else {
        bodyData.cargo = cargoSeleccionado;
      }

      const res = await fetch(endpoint, { 
        method: "POST", 
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify(bodyData) 
      });
      const data = await res.json();

      if (data.success) { 
        setMensaje({ text: `Permisos ABAC y de Alison guardados con éxito.`, type: "success" }); 
      } else { 
        setMensaje({ text: data.message || "Error al guardar.", type: "error" }); 
      }
    } catch (err) { 
      setMensaje({ text: "Error de red al sincronizar.", type: "error" }); 
    } finally { setLoading(false); }
  };

  const renderMatrizPermisos = () => {
    const moduloActual = modulosEstructura.find(m => m.id === moduloViendo) || modulosEstructura[0];
    if (!moduloActual) return <p className="text-gray-400 italic mt-6 text-center">No hay módulos disponibles.</p>;
    const moduloMacroActivo = modulosMacroActivos.some(id => String(id) === String(moduloActual.id));

    return (
      <div className="flex flex-col lg:flex-row gap-8 mt-8">
        
        {/* PANEL IZQUIERDO: Módulos */}
        <div className="w-full lg:w-[340px] bg-white/60 backdrop-blur-2xl p-6 rounded-[36px] border border-white/80 shadow-xl flex flex-col gap-3 h-fit animate-fade-in-up">
          <h4 className="text-[11px] font-black text-slate-400 uppercase tracking-widest mb-2 px-2">Módulos del Sistema</h4>
          {modulosEstructura.map((mod) => (
            <div 
              key={mod.id} 
              onClick={() => setModuloViendo(mod.id)} 
              className={`flex items-center justify-between p-4 rounded-3xl cursor-pointer transition-all duration-300 ${
                moduloViendo === mod.id 
                  ? "bg-white shadow-md border-transparent ring-2 ring-blue-500/20 transform scale-[1.02]" 
                  : "hover:bg-white/70 border border-transparent"
              }`}
            >
              <div className="flex items-center gap-4 group">
                <div className={`w-11 h-11 rounded-2xl flex items-center justify-center text-lg transition-colors icon-bounce ${
                  moduloViendo === mod.id ? "bg-blue-50 text-blue-600 shadow-inner" : "bg-slate-100/60 text-slate-400"
                }`}>
                  {mod.icono || '📁'}
                </div>
                <span className={`text-xs font-black ${moduloViendo === mod.id ? 'text-blue-900' : 'text-slate-600'}`}>
                  {mod.nombre}
                </span>
              </div>
              {modulosMacroActivos.some(id => String(id) === String(mod.id)) && (
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.8)]"></div>
              )}
            </div>
          ))}
        </div>

        {/* PANEL DERECHO: Submódulos y Acciones */}
        <div className="w-full lg:flex-1 bg-white/60 backdrop-blur-3xl p-8 sm:p-10 rounded-[36px] border border-white/80 shadow-2xl flex flex-col h-fit min-h-[500px] animate-fade-in-up delay-200">
          
          <div className="flex items-center justify-between gap-4 mb-8 pb-6 border-b border-slate-200/50">
            <div className="flex items-center gap-5">
              <div className={`w-18 h-18 rounded-[24px] flex items-center justify-center text-3xl shadow-inner transition-all duration-500 ${
                moduloMacroActivo ? 'bg-gradient-to-br from-blue-500 to-blue-700 text-white shadow-blue-500/40' : 'bg-slate-200/60 text-slate-400'
              }`}>
                {moduloActual.icono || '📁'}
              </div>
              <div>
                <h3 className={`text-2xl font-black tracking-tight ${moduloMacroActivo ? 'text-slate-900' : 'text-slate-400'}`}>
                  {moduloActual.nombre}
                </h3>
                <p className="text-xs text-slate-500 font-bold mt-1">Control General y Filtros ABAC Avanzados.</p>
              </div>
            </div>
            
            <label className={`flex items-center gap-4 cursor-pointer p-2.5 pr-5 rounded-full transition-all duration-300 ${
              moduloMacroActivo ? 'bg-emerald-50/80 border border-emerald-200 shadow-sm animate-pulse-soft' : 'bg-slate-100 border border-slate-200'
            }`}>
              <div className={`relative w-14 h-8 rounded-full transition-colors duration-300 ease-in-out ${moduloMacroActivo ? 'bg-emerald-500' : 'bg-slate-300'}`}>
                <div className={`absolute top-1 left-1 bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${moduloMacroActivo ? 'translate-x-6' : 'translate-x-0'}`}></div>
              </div>
              <span className={`text-[11px] font-black tracking-wider uppercase ${moduloMacroActivo ? 'text-emerald-700' : 'text-slate-400'}`}>
                {moduloMacroActivo ? "Habilitado" : "Apagado"}
              </span>
              <input type="checkbox" className="hidden" checked={moduloMacroActivo} onChange={() => handleToggleModuloMacro(moduloActual.id)} />
            </label>
          </div>

          {moduloMacroActivo ? (
            <div className="flex flex-col gap-6 animate-fade-in-up delay-400">
              <h4 className="text-[11px] font-black text-blue-600 uppercase tracking-widest mb-1">Permisos de Sub-Módulos</h4>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {moduloActual.subForms && moduloActual.subForms.length > 0 ? [...new Set(moduloActual.subForms)].map((form, idx) => {
                  const configPermiso = permisosAvanzados[form];
                  const estaActivo = configPermiso !== undefined;

                  const soportaAccionesCRUD = form === "Sistema de Gestión" || [
                    "Medidas Disciplinarias", "Contratos", "Formatos y Trámites", "Proceso Permisos", 
                    "Directorio", "Organigrama", "Reglamento Interno", "Políticas T.H.", "Onboarding", "Comunicados", 
                    "Manuales de Cargo", "Perfiles de Cargos", "Rutas", "Personal con Discapacidad", "Maternas",
                    "Actas de Compromiso"
                  ].includes(String(form).trim());

                  return (
                    <div key={idx} className={`flex flex-col p-6 rounded-[28px] border transition-all duration-300 glass-reflection ${
                      estaActivo ? "bg-white/90 shadow-xl border-blue-300/60 ring-2 ring-blue-500/10" : "bg-white/40 border-white/60 hover:bg-white/60"
                    }`}>
                      {/* Control de Activación Principal de la Tarjeta */}
                      <div className="flex justify-between items-center cursor-pointer pb-2" onClick={() => handleTogglePermisoMicro(form)}>
                        <div className="flex items-center gap-4">
                          <div className={`w-7 h-7 rounded-xl flex items-center justify-center transition-all duration-300 ${
                            estaActivo ? "bg-blue-600 text-white shadow-md shadow-blue-500/30" : "bg-white border-2 border-slate-300"
                          }`}>
                            {estaActivo && <span className="text-xs font-black">✓</span>}
                          </div>
                          <span className={`text-sm font-black ${estaActivo ? "text-slate-900" : "text-slate-600"}`}>{form}</span>
                        </div>
                      </div>

                      {estaActivo && (
                        <div className="mt-4 pt-6 border-t border-slate-100 flex flex-col gap-5 animate-fade-in">
                          <div className="w-full">
                            <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Alcance de Sede:</label>
                            <div className="relative">
                              <select 
                                value={accesoGlobal ? "GLOBAL" : (configPermiso?.alcance || "PROPIA")} 
                                disabled={accesoGlobal} 
                                onChange={(e) => handleCambiarAlcance(form, 'alcance', e.target.value)} 
                                className="w-full appearance-none bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3 text-xs font-bold text-slate-700 disabled:opacity-60 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all cursor-pointer"
                              >
                                <option value="PROPIA">Solo su propia sede vinculada</option>
                                <option value="ESPECIFICA">Sedes en específico (Personalizado)</option>
                                <option value="GLOBAL">🌐 Todas las sedes (Control Total)</option>
                              </select>
                              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-slate-400">▾</div>
                            </div>
                          </div>

                          {soportaAccionesCRUD && (
                            <div className="w-full bg-slate-50/80 p-4 rounded-2xl border border-slate-200/60">
                              <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3">Acciones Permitidas (CRUD):</label>
                              <div className="flex flex-col gap-3">
                                <label className="flex items-center gap-3 cursor-pointer group">
                                  <div className={`w-5 h-5 rounded-lg flex items-center justify-center transition-all ${configPermiso.crear ? "bg-emerald-500 text-white shadow-md shadow-emerald-500/30" : "bg-white border-2 border-slate-300 group-hover:border-emerald-400"}`}>
                                    {configPermiso.crear && <span className="text-xs font-bold">✓</span>}
                                  </div>
                                  <span className="text-xs font-bold text-slate-700">Crear / Subir</span>
                                  <input type="checkbox" className="hidden" checked={configPermiso.crear || false} onChange={() => handleToggleAccion(form, 'crear')} />
                                </label>

                                <label className="flex items-center gap-3 cursor-pointer group">
                                  <div className={`w-5 h-5 rounded-lg flex items-center justify-center transition-all ${configPermiso.editar ? "bg-amber-500 text-white shadow-md shadow-amber-500/30" : "bg-white border-2 border-slate-300 group-hover:border-amber-400"}`}>
                                    {configPermiso.editar && <span className="text-xs font-bold">✓</span>}
                                  </div>
                                  <span className="text-xs font-bold text-slate-700">Editar / Modificar</span>
                                  <input type="checkbox" className="hidden" checked={configPermiso.editar || false} onChange={() => handleToggleAccion(form, 'editar')} />
                                </label>

                                <label className="flex items-center gap-3 cursor-pointer group">
                                  <div className={`w-5 h-5 rounded-lg flex items-center justify-center transition-all ${configPermiso.eliminar ? "bg-rose-500 text-white shadow-md shadow-rose-500/30" : "bg-white border-2 border-slate-300 group-hover:border-rose-400"}`}>
                                    {configPermiso.eliminar && <span className="text-xs font-bold">✓</span>}
                                  </div>
                                  <span className="text-xs font-bold text-slate-700">Eliminar</span>
                                  <input type="checkbox" className="hidden" checked={configPermiso.eliminar || false} onChange={() => handleToggleAccion(form, 'eliminar')} />
                                </label>
                              </div>
                            </div>
                          )}

                          {configPermiso?.alcance === "ESPECIFICA" && !accesoGlobal && (
                            <div className="w-full animate-fade-in border-t border-slate-100 pt-4">
                              <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-3">Sedes Autorizadas:</label>
                              <div className="grid grid-cols-2 gap-2">
                                {sedes.map(s => {
                                  const isChecked = (configPermiso.sedes_ids || []).includes(s.codigo_bodega); 
                                  return (
                                    <label key={s.id} className={`flex items-center gap-2 px-3 py-2 rounded-xl border cursor-pointer transition-all duration-200 ${
                                      isChecked ? 'bg-blue-50 border-blue-300 shadow-sm' : 'bg-white border-slate-200 hover:bg-slate-50'
                                    }`}>
                                      <div className={`w-4 h-4 rounded-md border flex items-center justify-center transition-colors ${isChecked ? 'bg-blue-600 border-blue-600' : 'bg-white border-slate-300'}`}>
                                        {isChecked && <span className="text-white text-[10px] font-bold">✓</span>}
                                      </div>
                                      <span className={`text-[11px] font-bold ${isChecked ? 'text-blue-900' : 'text-slate-600'}`}>{s.nombre}</span>
                                      <input type="checkbox" className="hidden" checked={isChecked} onChange={() => handleToggleSedeMultiple(form, s.codigo_bodega)} />
                                    </label>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                }) : (
                  <div className="col-span-2 p-8 text-center border-2 border-dashed border-slate-200 rounded-[28px] bg-white/40">
                    <p className="text-sm font-bold text-slate-400">Este módulo no tiene sub-opciones configurables.</p>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="flex-1 flex flex-col items-center justify-center opacity-40 py-20">
              <span className="text-7xl mb-6 grayscale">🔒</span>
              <p className="text-slate-500 font-bold text-base text-center max-w-xs tracking-tight">El módulo está desactivado para este perfil.</p>
            </div>
          )}

          <div className="mt-auto pt-8 flex justify-end border-t border-slate-200/50 mt-8">
            <button 
              onClick={handleGuardarPermisosUnificados} 
              disabled={loading} 
              className="btn-glow px-10 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-xs uppercase tracking-widest font-black rounded-2xl shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 hover:-translate-y-1 transition-all duration-300 disabled:opacity-50 disabled:transform-none flex items-center gap-3 cursor-pointer"
            >
              {loading ? (
                <>
                  <span className="animate-spin text-lg">⚙️</span> Sincronizando...
                </>
              ) : (
                <>
                  <span className="text-lg">💾</span> Guardar Configuración ABAC
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-100 via-slate-200/50 to-blue-50/30 p-4 md:p-8 font-sans text-slate-900">
      <div className="w-full max-w-[98%] mx-auto">
        
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mb-10 bg-white/60 backdrop-blur-2xl p-6 rounded-[32px] shadow-sm border border-white/80 animate-fade-in-down">
          <div>
            <h1 className="text-3xl font-black tracking-tight text-slate-800">Control ABAC <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-emerald-500">2</span></h1>
            <p className="text-sm text-slate-500 font-medium mt-1">Gestión de atributos, accesos y permisos por capas.</p>
          </div>
          <button onClick={onBackToMenu} className="px-6 py-3 bg-white hover:bg-slate-50 text-slate-700 text-xs font-black tracking-wider uppercase rounded-2xl transition-all shadow-sm border border-slate-200 cursor-pointer flex items-center gap-2">
            <span></span> Volver al Menú
          </button>
        </div>

        <div className="flex justify-center mb-8 animate-fade-in-up delay-100">
          <div className="flex p-1.5 bg-slate-200/70 backdrop-blur-md rounded-2xl w-full max-w-md shadow-inner border border-slate-200/50">
            <button onClick={() => setPestanaActiva("empleado")} className={`flex-1 py-3 text-[11px] font-black uppercase tracking-widest rounded-xl transition-all duration-300 ${pestanaActiva === "empleado" ? "bg-white text-blue-700 shadow-md" : "text-slate-500 hover:text-slate-700"}`}>
              Por Empleado
            </button>
            <button onClick={() => setPestanaActiva("cargo")} className={`flex-1 py-3 text-[11px] font-black uppercase tracking-widest rounded-xl transition-all duration-300 ${pestanaActiva === "cargo" ? "bg-white text-blue-700 shadow-md" : "text-slate-500 hover:text-slate-700"}`}>
              Por Cargo (Rol)
            </button>
          </div>
        </div>
        
        {/* BARRA DE BÚSQUEDA Y SWITCHES GLOBALES (ACCESO GLOBAL + ALISON AI) */}
        <div className="flex flex-col xl:flex-row gap-6 items-stretch xl:items-center justify-between mb-8 animate-fade-in-up delay-200">
          
          <div className="w-full xl:w-1/3">
            {pestanaActiva === "empleado" ? (
              <form onSubmit={handleBuscarEmpleado} className="relative group">
                <input type="text" value={busqueda} onChange={(e) => setBusqueda(e.target.value)} placeholder="Ingrese cédula del colaborador..." className="w-full bg-white/70 backdrop-blur-xl border border-slate-200 rounded-2xl pl-12 pr-32 py-4 text-sm font-bold focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 shadow-sm transition-all" />
                <span className="absolute left-4 top-4 text-slate-400 text-lg">👤</span>
                <button type="submit" disabled={loading} className="absolute right-2 top-2 bottom-2 px-6 bg-blue-600 hover:bg-blue-700 text-white font-bold text-xs rounded-xl transition-colors cursor-pointer">Buscar</button>
              </form>
            ) : (
              <div className="relative">
                <select value={cargoSeleccionado} onChange={(e) => setCargoSeleccionado(e.target.value)} className="w-full appearance-none bg-white/70 backdrop-blur-xl border border-slate-200 rounded-2xl pl-12 pr-10 py-4 text-sm font-bold text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 shadow-sm transition-all cursor-pointer">
                  <option value="">-- Seleccione un Cargo Administrativo --</option>
                  <option value="SUPER_ADMIN">SUPER ADMIN</option>
                  <option value="GERENTE">GERENTE</option>
                  {cargosBD.map((c, idx) => <option key={idx} value={c}>{c}</option>)}
                </select>
                <span className="absolute left-4 top-4 text-slate-400 text-lg">💼</span>
                <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-slate-400">▾</div>
              </div>
            )}
          </div>

          {((pestanaActiva === "empleado" && empleadoEncontrado) || (pestanaActiva === "cargo" && cargoSeleccionado)) && (
            <div className="flex flex-col sm:flex-row gap-4 flex-1">
              
              {/* Switch de Acceso Global */}
              <label className="flex items-center justify-between flex-1 gap-4 p-4 bg-gradient-to-r from-blue-50/80 to-indigo-50/80 backdrop-blur-xl border border-blue-200/60 rounded-2xl cursor-pointer hover:shadow-md transition-all group">
                <div className="flex gap-3 items-center">
                  <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center shadow-sm text-blue-600 text-base">🌐</div>
                  <div>
                    <span className="block text-xs font-black text-blue-900 tracking-tight">Acceso Global</span>
                    <span className="block text-[10px] text-blue-600/80 font-bold">Todas las sedes.</span>
                  </div>
                </div>
                <div className={`relative w-12 h-7 rounded-full transition-colors duration-300 ease-in-out ${accesoGlobal ? 'bg-blue-600' : 'bg-slate-300'}`}>
                  <div className={`absolute top-1 left-1 bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${accesoGlobal ? 'translate-x-5' : 'translate-x-0'}`}></div>
                </div>
                <input type="checkbox" className="hidden" checked={accesoGlobal} onChange={(e) => setAccesoGlobal(e.target.checked)} />
              </label>

              {/* Switch de Asistente Alison AI */}
              <label className="flex items-center justify-between flex-1 gap-4 p-4 bg-gradient-to-r from-purple-50/80 to-fuchsia-50/80 backdrop-blur-xl border border-purple-200/60 rounded-2xl cursor-pointer hover:shadow-md transition-all group">
                <div className="flex gap-3 items-center">
                  <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center shadow-sm text-purple-600 text-base">🌟</div>
                  <div>
                    <span className="block text-xs font-black text-purple-900 tracking-tight">Asistente Alison AI</span>
                    <span className="block text-[10px] text-purple-600/80 font-bold">Habilitar widget IA.</span>
                  </div>
                </div>
                <div className={`relative w-12 h-7 rounded-full transition-colors duration-300 ease-in-out ${accesoAlison ? 'bg-purple-600' : 'bg-slate-300'}`}>
                  <div className={`absolute top-1 left-1 bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${accesoAlison ? 'translate-x-5' : 'translate-x-0'}`}></div>
                </div>
                <input type="checkbox" className="hidden" checked={accesoAlison} onChange={(e) => setAccesoAlison(e.target.checked)} />
              </label>

            </div>
          )}
        </div>

        {mensaje.text && (
          <div className={`mb-8 p-4 rounded-2xl text-sm font-bold flex items-center gap-3 animate-fade-in-down ${mensaje.type === "success" ? "bg-emerald-50 text-emerald-800 border border-emerald-200" : "bg-rose-50 text-rose-800 border border-rose-200"}`}>
            <span className="text-xl">{mensaje.type === "success" ? "✅" : "⚠️"}</span> {mensaje.text}
          </div>
        )}

        {pestanaActiva === "empleado" && empleadoEncontrado && (
          <div className="bg-white/70 backdrop-blur-xl p-5 rounded-3xl border border-white flex items-center gap-5 w-fit mb-4 shadow-sm animate-fade-in-up">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center font-black text-2xl rounded-2xl shadow-inner shadow-blue-900/20">
              {String(empleadoEncontrado?.nombres || empleadoEncontrado?.correo || 'U').charAt(0).toUpperCase()}
            </div>
            <div>
              <h4 className="text-base font-black text-slate-800">{empleadoEncontrado.nombres}</h4>
              <p className="text-[11px] text-slate-500 font-bold uppercase tracking-widest mt-1">
                Cargo: <span className="text-blue-600">{empleadoEncontrado.cargo}</span>
              </p>
              <p className="text-[10px] text-slate-400 font-semibold mt-0.5">
                Documento: {empleadoEncontrado.documento}
              </p>
            </div>
          </div>
        )}

        {((pestanaActiva === "empleado" && empleadoEncontrado) || (pestanaActiva === "cargo" && cargoSeleccionado)) && renderMatrizPermisos()}
      </div>
    </div>
  );
}